/**
 * When the launcher runs from the Home Screen, the notifications nudge is a card at the
 * top of Home: "ask" while the permission is undecided, "denied" (how to turn it back on
 * in Settings) once it was refused. "Not now" hides it for a week. Pure, unit-tested.
 */

export const NOTIFY_CARD_SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;

export type NotifyCardState = 'ask' | 'denied' | null;

export function notifyCardState(input: {
  standalone: boolean;
  permission: NotificationPermission | 'unsupported';
  /** The deployment has VAPID keys (push.publicKey is not null). */
  pushConfigured: boolean;
  snoozedUntil: number;
  now: number;
}): NotifyCardState {
  if (!input.standalone || !input.pushConfigured || input.now < input.snoozedUntil) return null;
  if (input.permission === 'default') return 'ask';
  if (input.permission === 'denied') return 'denied';
  return null;
}
